import { F } from '@angular/cdk/scrolling-module.d-ud2XrbF8';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EtatTraitement, PieceNonIntegreeDto, PiecesLexiClient, TraitementDto, TraitementsLexiClient } from '@lexi-clients/lexi';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-pieces-non-integrees-popup',
  templateUrl: './pieces-non-integrees-popup.component.html',
  styleUrls: ['./pieces-non-integrees-popup.component.scss'],
  standalone: false
})
export class PiecesNonIntegreesPopupComponent implements OnInit {
  @Input() canDisplay : boolean = false;

  piecesNonIntegrees: PieceNonIntegreeDto[] = [];
  traitements: TraitementDto[] = [];
  visible : boolean = false;
  exportEnable: boolean = true;
  showTraitements: boolean = false;
  refreshManuelTraitementEnabled: boolean = false;
  nbPiecesNonIntegreesInitial = 0;

  constructor(
    private readonly piecesLexiClient: PiecesLexiClient,
    private readonly traitementsLexiClient: TraitementsLexiClient
  ) {}

  async ngOnInit(){
    await this.chargerPiecesNonIntegrees();
    this.nbPiecesNonIntegreesInitial = this.piecesNonIntegrees.length;
    if(this.canDisplay && this.piecesNonIntegrees.length > 0){
      this.visible = true;
    }
  }

  async chargerPiecesNonIntegrees(){
    this.piecesNonIntegrees = await lastValueFrom(
      this.piecesLexiClient.rechercherPiecesNonIntegreesBO()
    );

    if (this.piecesNonIntegrees.length === 0) {
      this.visible = false;
    }
  }

  async relancerIntegrationBO(): Promise<void> {
    try {
      this.exportEnable = false;
      this.showTraitements = true;

      const pieceIds = this.piecesNonIntegrees.map(x => x.id);
      this.traitements = await lastValueFrom(
        this.traitementsLexiClient.relancerTraitementsTPVAvecPieces(pieceIds)
      );
      // Après 5 relance, on arrête la boucle et on rend le bouton de refresh manuel actif
      let relanceCount = 0;
      while(this.traitements.some(x => x.etat !== EtatTraitement.termine) && this.visible && relanceCount < 5) {
        relanceCount++;
        await new Promise(resolve => setTimeout(resolve, 2000));
        const ids = this.traitements.map(x => x.id);
        this.traitements = await lastValueFrom(this.traitementsLexiClient.getTraitementsById(ids));
      }
      if (relanceCount >= 5) {
        this.refreshManuelTraitementEnabled = true;
      }
      await this.chargerPiecesNonIntegrees();
    } finally {
      this.exportEnable = true;
    }
  }
  async handleRefreshTraitements(event : any){
    const ids = this.traitements.map(x => x.id);
    this.traitements = await lastValueFrom(this.traitementsLexiClient.getTraitementsById(ids));
  }
}
